<template>
  <div class="news-all">
    <TableHeaderBasic
      @searchKeyWord="$store.dispatch('fetchNewlyAddedSurveyAll')"
      @searchDate="$store.dispatch('fetchNewlyAddedSurveyAll')"
    ></TableHeaderBasic>
    <TablePagination
      @updatePage="$store.dispatch('fetchNewlyAddedSurveyAll')"
    ></TablePagination>
    <TableList
      :isSelectable="$store.getters.loggedInInfo.is_admin"
      :fields="fields"
      :items="$store.getters.newlyAddedSurveyAllList"
      @click="openModal($event)"
      @toDetail="toDetail"
    >
    </TableList>

    <!-- modal -->
    <b-modal ref="double-check-delete">
      <p class="text-center">是否刪除？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >確定</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import TableHeaderBasic from "@/components/TableHeaderBasic.vue";
import TablePagination from "@/components/TablePagination.vue";
export default {
  components: {
    TableList,
    TableHeaderBasic,
    TablePagination
  },
  computed: {
    fields() {
      return [
        { key: "created_at", label: "創建日期" },
        { key: "stock.stock_symbol", label: "股票代號" },
        { key: "stock.company_name", label: "公司名稱" },
        { key: "title", label: "標題" },
        { key: "user", label: "撰寫者" }
      ];
    }
  },
  data() {
    return {
      deleteData: {
        research_ids: []
      }
    };
  },
  methods: {
    openModal(selectedList) {
      this.$refs["double-check-delete"].show();
      this.setDeleteData(selectedList);
    },
    setDeleteData(selectedList) {
      this.deleteData.research_ids = selectedList.map(item => item.id);
    },
    submit() {
      this.$store.dispatch("deleteOneSurvey", this.deleteData).then(() => {
        this.$refs["double-check-delete"].hide();
        this.$store.dispatch("fetchNewlyAddedSurveyAll");
      });
    },
    toDetail(oneSurvey) {
      this.$router.push({
        name: "newlyAddedOneSurveyRead",
        params: { oneSurveyId: oneSurvey.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
